import { render, staticRenderFns } from "./LayoutWrapper.vue?vue&type=template&id=0bbd08d1&scoped=true&"
import script from "./LayoutWrapper.vue?vue&type=script&lang=ts&"
export * from "./LayoutWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd08d1",
  null
  
)

export default component.exports